import { Observable } from 'rxjs/Observable';

import { BaseModal } from './modal-base';

export abstract class ConfirmationBaseModal<T, V> extends BaseModal<T> {

    okText: string = 'OK';
    cancelText: string = 'Cancel';


    onOk(e: MouseEvent) {
        e.preventDefault();
        if (this.isDataValid()) {
            this.closeDialog();
            this.onOkEvent(e);
        }
    }

    onCancel(e: MouseEvent) {
        e.preventDefault();
        this.closeDialog()
        this.onCancelEvent(e);
    }

    showDialog(args: T): Observable<V> {
        let result = this.onActivate(args);
        this.initialize();
        return result;
    }

    abstract onOkEvent(e: MouseEvent): void;
    abstract onCancelEvent(e: MouseEvent): void;
    abstract isDataValid(): boolean;

}



// WEBPACK FOOTER //
// ./src/app/modals/confirmation-modal.ts